import React, { Component, Fragment } from "react";
import { Container, Col, Row, Label, Button, FormGroup } from "reactstrap";

import { themeService } from "../../../../theme/service/activeTheme.service";

import { trackReportStyle } from "../style/index";
import "../style/style.css";
import { ruble } from "react-icons-kit/fa/ruble";
import { languageService } from "Language/language.service";
import { checkmark } from "react-icons-kit/icomoon/checkmark";
import SvgIcon from "react-icons-kit";
import _, { map } from "lodash";
import moment from "moment";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import { ButtonStyle } from "../../../../style/basic/commonControls";
import { iconToShow, iconTwoShow } from "../../variables";

import { SignatureImage } from "../../utils/SignatureImage";
import { NoExceptionsFound } from "./NoExceptionsFound";
import { getServerEndpoint } from "../../../../utils/serverEndpoint";
import { remedialActionUtil } from "../../../../config/RemedialActionConfig";
import { versionInfo } from "../../../MainPage/VersionInfo";

class DefectReportView extends Component {
  constructor(props) {
    super(props);

    this.displayModified = this.props.InspectionReportType === "All" ? true : false;
    this.config = {
      minAssetRows: 4,
      minIssueRows: 8,
    };
    this.checkFRACompliance = this.checkFRACompliance.bind(this);
  }
  checkFRACompliance(repairDate, RemedialAction) {
    if (this.displayModified) {
      return repairDate;
    } else {
      if (remedialActionUtil(RemedialAction, "repaired")) return repairDate;
      else return "";
    }
  }

  render() {
    const { isGaugeValueAvailable } = this.props;
    let issuesData = [];
    let gaugeFeatureSet = versionInfo.getFeatureset("showWidestGauge");

    let showGaugeValue = isGaugeValueAvailable && gaugeFeatureSet && gaugeFeatureSet.value === true;

    this.props.issuesData &&
      (issuesData = this.props.issuesData.map((issue, index) => {
        let comments = issue.RemedialAction && issue.RemedialAction;
        comments = issue.comments ? comments + " / " + issue.comments : comments;
        let selfRepair = remedialActionUtil(issue.RemedialAction, "repaired");
        let img = selfRepair ? this.props.signatureImage : issue.repairBySignature ? issue.repairBySignature : null;
        let repairByName = selfRepair ? this.props.userName : issue.repairByName ? issue.repairByName : null;
        return (
          <tr key={index}>
            <td style={{ wordWrap: "break-word" }}>{issue.assetName}</td>
            <td>{issue.MP}</td>
            {showGaugeValue && <td>{issue.gaugeValue}</td>}
            <td>{issue.Deficiency && <SvgIcon icon={checkmark} />}</td>
            <td>{issue.FRADefect && <SvgIcon icon={checkmark} />}</td>
            <td>{issue.Code}</td>
            <td>{issue.DefectDescription}</td>
            <td>
              <div>{comments}</div>
              {this.displayModified && issue.maintainerComments ? (
                <div style={{ display: "flow-root", padding: "0 5px", textAlign: "left" }}>
                  {" "}
                  <div style={{ fontWeight: 600, width: "fit-content", display: "contents" }}>{`${languageService(
                    "Maintainer",
                  )} ${languageService("Comments")}:`}</div>
                  {issue.maintainerComments}
                </div>
              ) : null}
            </td>
            {!this.props.disableRule213Config && <td>{issue.rule213Applied && <SvgIcon icon={checkmark} />}</td>}
            {this.displayModified && (
              <React.Fragment>
                <td>{img && <SignatureImage signatureImage={img} placement={"tableCell"} userName={repairByName} />}</td>
                <td>{this.checkFRACompliance(issue.repairDate, issue.RemedialAction)}</td>
              </React.Fragment>
            )}
          </tr>
        );
      }));
    let assetsData = [];
    this.props.assetsData &&
      (assetsData = this.props.assetsData.map((asset, index) => {
        return (
          <tr key={asset.unitId + index}>
            <td>
              {asset.attributes.primaryTrack && (
                <div style={{ marginRight: "10px", display: "inline-block" }}>
                  <span className="primary-track-logo" style={{ padding: "0" }}>
                    P
                  </span>
                </div>
              )}

              {<div style={{ display: "inline-block", width: "80%", verticalAlign: "middle", textAlign: "left" }}>{asset.unitId}</div>}
            </td>
            <td>{asset.start}</td>
            <td>{asset.end}</td>
            <td>{asset.HighRail}</td>
            <td>{asset.Walk}</td>
            <td>{asset.Train}</td>
            <td>{asset.Observe}</td>
          </tr>
        );
      }));

    const logo1Source = themeService(iconToShow);
    const logo2Source = themeService(iconTwoShow);
    const { additionalComments } = this.props.basicData;
    return (
      <React.Fragment>
        <div className="table-report last-page-break-print" style={{ ...themeService(trackReportStyle.mainStyle) }}>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={2}>{logo1Source && <img src={logo1Source} alt="Logo" style={themeService(trackReportStyle.logoStyle)} />}</Col>
                <Col md={8} style={{ textAlign: "center" }}>
                  <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "initial" }}>
                    {languageService(this.props.header)}
                  </h2>
                  {/*   <MyButton
                    className="d-print-none"
                    onClick={this.handleClick}
                    type="submit"
                    style={{
                      ...themeService(ButtonStyle.commonButton),
                      backgroundColor: "var(--first)",
                      boxShadow: "2px 2px 5px 0px rgb(0 0 0 / 75%)",
                      borderColor: "var(--first)",
                      whiteSpace: "pre-line",
                      height: "60px",
                    }}
                  >
                     {this.state.displayModified ? "FRA Report \n (Original)" : "Copy of Report \n (with Comments)"}
                  </MyButton>*/}
                </Col>
                <Col md={2}>
                  {logo2Source && (
                    <img src={logo2Source} alt="Logo" style={{ ...themeService(trackReportStyle.logoStyle), maxHeight: "125px" }} />
                  )}
                </Col>
                <span className="spacer"></span>
                <Col md={12}>
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: "20px" }}></th>
                        <th style={{ width: "20px" }}></th>
                        <th style={{ width: "30px" }}></th>
                        <th colSpan="3" scope="colgroup" data-field="inspection type" style={{ width: "30px", border: "1px solid black" }}>
                          {languageService("Inspection Type")}
                        </th>
                        <th style={{ width: "20px" }}></th>
                      </tr>
                      <tr>
                        <th data-field="date" style={{ width: "20px" }}>
                          {languageService("Date")}
                        </th>
                        <th data-field="line" style={{ width: "20px" }}>
                          {languageService("Line")}
                        </th>
                        <th data-field="weather" style={{ width: "30px" }}>
                          {languageService("Weather")}
                        </th>
                        <th data-field="weekly" style={{ width: "10px", border: "1px solid black" }}>
                          {languageService("Required")}
                        </th>
                        <th data-field="Weather" style={{ width: "10px", border: "1px solid black" }}>
                          {languageService("Weather")}
                        </th>
                        <th data-field="special" style={{ width: "10px", border: "1px solid black" }}>
                          {languageService("Special")}
                        </th>
                        <th data-field="inspector" style={{ width: "20px" }}>
                          {languageService("Inspector")}
                        </th>
                      </tr>
                    </thead>
                    <tbody key={"mainBody"}>
                      <tr>
                        <td>{this.props.basicData.Date}</td>
                        <td>{this.props.basicData.Line}</td>
                        <td>{this.props.basicData.Weather}</td>
                        <td>{this.props.basicData.InspectionWeekly}</td>
                        <td>{this.props.basicData.InspectionWeather}</td>
                        <td>{this.props.basicData.InspectionSpecial}</td>
                        <td>{this.props.basicData.Inspector}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
                <Col md={1}></Col>
                <Col md={10}>
                  <table>
                    <thead>
                      <tr>
                        <th data-field="track" style={{ width: "20px" }}>
                          {languageService("Track")}
                        </th>
                        <th data-field="from" style={{ width: "20px" }}>
                          {languageService("From")}
                        </th>
                        <th data-field="to" style={{ width: "20px" }}>
                          {languageService("To")}
                        </th>
                        <th data-field="hirail" style={{ width: "10px" }}>
                          Hi-{languageService("rail")}
                        </th>
                        <th data-field="walk" style={{ width: "10px" }}>
                          {languageService("Walk")}
                        </th>
                        <th data-field="train" style={{ width: "10px" }}>
                          {languageService("Train")}
                        </th>
                        <th data-field="observe" style={{ width: "10px" }}>
                          {languageService("Observe")}
                        </th>
                      </tr>
                    </thead>
                    <tbody key={"assetBody"}>
                      {assetsData}
                      {addEmptyColsIfNotEnough(assetsData, this.config.minAssetRows, 7)}
                    </tbody>
                  </table>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row>
                <Col md={12}>
                  <table>
                    <thead>
                      <tr>
                        <th data-field="name" style={{ width: "10px" }}>
                          {languageService("Asset")}
                        </th>
                        <th data-field="mp" style={{ width: "10px" }}>
                          {languageService("MP")}
                        </th>
                        {showGaugeValue && (
                          <th data-field="mp" style={{ width: "10px" }}>
                            {languageService("Widest Gauge")}
                          </th>
                        )}
                        <th data-field="deficiency" style={{ width: "5px" }}>
                          {languageService("Def")}
                        </th>
                        <th data-field="fradefect" style={{ width: "5px" }}>
                          {languageService("Defect")}
                        </th>
                        <th data-field="code" style={{ width: "10px" }}>
                          {languageService("Code")}
                        </th>
                        <th data-field="defectdescription" style={{ width: "20px" }}>
                          {`${languageService("Defect / Deficiency Description")}`}
                        </th>
                        {/* <th data-field="remidialaction" style={{ width: "20px" }}>
                          {"Remedial Action"}
                        </th> */}

                        <th data-field="comments" style={{ width: "28px" }}>
                          {`${languageService("Remedial Action")} / ${languageService("Comments")}`}
                        </th>
                        {!this.props.disableRule213Config && (
                          <th data-field="2139Bneeded" style={{ width: "5px" }}>
                            {`213.9B ${languageService("Needed")}`}
                          </th>
                        )}
                        {this.displayModified && (
                          <React.Fragment>
                            <th data-field="signature" style={{ width: "15px" }}>
                              {`${languageService("Maintainer")} \n ${languageService("Signature")}`}
                            </th>
                            <th data-field="daterepaired" style={{ width: "10px" }}>
                              {`${languageService("Date")} \n ${languageService("Repaired")}`}
                            </th>
                          </React.Fragment>
                        )}
                      </tr>
                    </thead>

                    <tbody key={"issueBody"}>
                      {issuesData}
                      {addEmptyColsIfNotEnough(
                        issuesData,
                        this.config.minIssueRows,
                        colCalculator(this.displayModified, this.props.disableRule213Config, showGaugeValue),
                      )}
                      <NoExceptionsFound issuesData={issuesData} />
                    </tbody>
                  </table>
                </Col>
              </Row>
              <Row className="no-break">
                <Col md={7}>
                  <div
                    className="comment-box"
                    style={{ ...themeService(trackReportStyle.boxStyle), minHeight: "200px", height: "fit-content", padding: "10px" }}
                  >
                    <strong>{languageService("Comments")}:</strong>
                    <span style={{ display: "block", padding: "0px 15px 10px", whiteSpace: "break-spaces" }}>
                      {this.props.basicData.commentsDetail}
                    </span>
                    {this.displayModified && additionalComments && additionalComments.length > 0 ? (
                      <Fragment>
                        <strong>{languageService("Additional Comments")}:</strong>
                        <ul>
                          {additionalComments.map((comm, i) => (
                            <li key={`add-comm-${i}`}>{comm}</li>
                          ))}
                        </ul>
                      </Fragment>
                    ) : null}
                  </div>
                </Col>
                <Col md={3}>
                  <div style={{ ...themeService(trackReportStyle.lineStyle), position: "relative", overflow: "hidden" }}>
                    {" "}
                    <div style={{ position: "absolute", bottom: "0", right: "0", left: "0" }}>
                      <SignatureImage signatureImage={this.props.signatureImage} placement={"tableCell"} />
                    </div>
                  </div>

                  <span style={themeService(trackReportStyle.spanStyle)}>{languageService("Inspector Signature")}</span>
                </Col>
                <Col md={2}>
                  <div style={{ ...themeService(trackReportStyle.lineStyle), textAlign: "center", position: "relative" }}>
                    <span style={{ position: "absolute", bottom: "0", right: "0", left: "0" }}>{this.props.basicData.Date}</span>
                  </div>
                  <span style={themeService(trackReportStyle.spanStyle)}>{languageService("Date")}</span>
                </Col>
              </Row>

              {this.props.workOrderUpdates && this.props.workOrderUpdates.length > 0 && (
                <Row className="no-break">
                  <Col md={7}>
                    <div
                      className="comment-box"
                      style={{
                        ...themeService(trackReportStyle.boxStyle),
                        marginTop: "15px",
                        minHeight: "150px",
                        height: "fit-content",
                        padding: "10px",
                      }}
                    >
                      <strong>{languageService("Defects Inspected")}:</strong>
                      <span
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                          gridAutoFlow: "row",
                          gap: "8px 18px",
                          padding: "0px 15px 10px",
                        }}
                      >
                        {this.props.workOrderUpdates.map((d, index) => (
                          <div key={index}>{d.mrNumber}</div>
                        ))}
                      </span>
                    </div>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}
DefectReportView.defaultProps = {
  basicData: {},
  assetsData: [],
};

export default DefectReportView;

function addEmptyColsIfNotEnough(mapArray, minRows, cols) {
  let emptyRows = null;
  let countToAdd = minRows - mapArray.length;
  if (countToAdd > 0) {
    emptyRows = [];
    for (let i = 0; i < countToAdd; i++) {
      let row = <tr key={i + "emptyRow"}>{getCols(cols)}</tr>;
      emptyRows.push(row);
    }
  }
  return emptyRows;
}

function getCols(num) {
  let cols = [];
  for (let i = 0; i < num; i++) {
    cols.push(<td key={i + "emptyCol"}></td>);
  }
  return cols;
}
function colCalculator(displayRepaired, disableRule213, showGaugeValue) {
  let col = 10;
  col = displayRepaired ? col : 8;
  col = disableRule213 ? col - 1 : col;
  col = showGaugeValue ? col + 1 : col;
  return col;
}



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/LineInspection/DefectReportView.jsx